import { useState } from "react";
import { Link } from "react-router-dom";
import API from "../config/api.js";

export default function CaptionCard({
  caption,
  onCopy,
  onUsed,
  onFavorite,
}) {
  const [isFavorite, setIsFavorite] = useState(
    caption.idcaptionfavorite !== null
  );
  const [isUsed, setIsUsed] = useState(caption.idcaptionused !== null);

 const handleDraft = () => {
  window._draft_prompt_caption_add?.(caption.idcaption, caption.content);
};

  const handleAssistant = () => {
    window._assistant_text_add?.(caption.content);
  };

  const handleUsed = async () => {
    const newUsed = !isUsed;
    setIsUsed(newUsed);

    try {
      const formData = new FormData();
      formData.append("idcaption", caption.idcaption);

      const res = await fetch(`${API.captions}?used`, {
        method: "POST",
        credentials: "include",
        body: formData,
      });

      const status = await res.json();
      setIsUsed(status === true);
      onUsed?.(caption.idcaption, status === true);
    } catch (err) {
      setIsUsed(!newUsed);
    }
  };

  const handleFavorite = async () => {
    const newFav = !isFavorite;
    setIsFavorite(newFav);

    try {
      const formData = new FormData();
      formData.append("idcaption", caption.idcaption);

      const res = await fetch(`${API.captions}?favorite`, {
        method: "POST",
        credentials: "include",
        body: formData,
      });

      const status = await res.json();
      setIsFavorite(status === true);
      onFavorite?.(caption.idcaption, status === true);
    } catch (err) {
      setIsFavorite(!newFav);
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(caption.content);
      onCopy?.(caption.content);
    } catch (err) {
      alert("Error!");
    }
  };

  const isNew =
    new Date(caption.date) >
    new Date(Date.now() - 20 * 24 * 60 * 60 * 1000);

  const categories = Array.isArray(caption.categories)
    ? caption.categories
    : [];

  return (
    <div
      className={`card rounded-4 h-100 border caption caption-${caption.idcaption} animate__animated animate__fadeIn animate__slow`}
    >
      <div className="card-header bg-white rounded-4 border-0 p-3 pb-0 position-relative">
        {isNew && (
          <div className="position-absolute top-0 end-0">
            <div className="bg-secondary-light text-dark rounded shadow-sm py-2 text-center m-2 px-3 small new-tag">
              NEW
            </div>
          </div>
        )}

        <div className="mb-2 categories">
          {categories.map(
            (category) =>
              category.type === "caption" && (
                <Link
                  key={`${caption.idcaption}-${category.idcategory}`}
                  className="link-primary me-2 mb-2 fw-bold"
                  to={`/captions?idcategory=${category.idcategory}`}
                >
                  {category.title}
                </Link>
              )
          )}
        </div>

        <h5 className="card-title fs-5 mb-0">{caption.title}</h5>
      </div>

      <div className="card-body">
        <p className="card-text caption-content">{caption.content}</p>
      </div>

      <div className="card-footer rounded-bottom-4 bg-transparent p-3">
        <div className="row align-items-center">
          <div className="col-auto action-buttons d-block">
            <button className="btn btn-caption-edit me-2" onClick={handleDraft}>
              <i className="fi fi-rr-add fs-5"></i>
            </button>
          </div>

          <div className="col text-end action-buttons">
            <div className="dropup d-inline-block z-3">
              <button
                className="btn text-white"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fi fi-rr-menu-dots"></i>
              </button>

              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <button className="dropdown-item" onClick={handleAssistant}>
                    <i className="fi fi-rr-bulb me-2"></i> Open in Estelle
                  </button>
                </li>
                <li>
                  <button className="dropdown-item" onClick={handleCopy}>
                    <i className="fi fi-rr-duplicate me-2"></i> Copy to clipboard
                  </button>
                </li>
                <li>
                  <button className="dropdown-item" onClick={handleUsed}>
                    {isUsed ? (
                      <>
                        <i className="fi fi-rr-checkbox me-2"></i> Used
                      </>
                    ) : (
                      <>
                        <i className="fi fi-rr-square me-2"></i> Mark as used
                      </>
                    )}
                  </button>
                </li>
                <li>
                  <button className="dropdown-item" onClick={handleFavorite}>
                    {isFavorite ? (
                      <>
                        <i className="fi fi-sr-heart me-2"></i> Favorited
                      </>
                    ) : (
                      <>
                        <i className="fi fi-rr-heart me-2"></i> Mark as favorite
                      </>
                    )}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}